import { useState, useEffect, useCallback, useRef } from "react";
import { Tabs, Row, Col, Result, Collapse, Divider, Input } from "antd";
import { useParams, useLocation, Link } from "react-router-dom";
import "../components/CollectionProducts/CollectionProducts.scss";
import Question from "../icons/Question";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import axiosInstance from "../config/axios-instance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import faqbaseimage from "../img/faqbaseimage.svg";
import { v4 as uuidv4 } from "uuid";
import { UserOutlined } from "@ant-design/icons";
import backArrow from "../img/backArrow.png";
import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";

interface Props {}

export const Faq = (props: Props) => {
  const location = useLocation();
  const params: any = useParams();
  const { Panel } = Collapse;

  const [faqCategory, setFaqCategory] = useState<Array<any>>([]);
  const [faq, setFaq] = useState<Array<any>>([]);
  const [search, setSearch] = useState<Array<any>>([]);
  const [active, setActive] = useState("-1");
  const [noResult, setResult] = useState(false);
  const [activeAllQuestion, setActiveAllQuestion] = useState<any>(null);

  const [activeQuestion, setActiveQuestion] = useState<any>(null);
  const [activeQuestionSearch, setActiveQuestionSearch] = useState<any>(null);
  const [firstShow, setFirstShow] = useState("");

  const [question, setQuestion] = useState<any>(null);

  function useQueryy() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQueryy();
  const fetchFaqCategory = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/faq/categories/all`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => {
      setFaqCategory(res.data);
    });
  };

  const fetchFaqs = (id: any) => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/faq/categories/` + id,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => {
      setFaq(res.data);
    });
  };

  const onChange = (key: string) => {
    setActive(key);
    fetchFaqs(key);
    setActiveQuestion(null);
    setcheckQuestion("");
    setFirstShow(key);
  };
  /* 
  const search = (e: any) => {
    setKeyword(e.target.value);
    setLoading(true);
    if (!e.target.value) return;
    axiosInstance({
      method: "get",
      url: `/products?name=${e.target.value}`,
    })
      .then((res) => {
        setProducts(res.data);
      })
      .catch((err: any) =>{});
    // dispatch(filterByTyping(e.target.value));
  }; */

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    console.log(value);
    axiosInstance({
      method: "get",
      url: `/faqsearch?search=${value}`,
    })
      .then((res) => {
        if (value && res.data.length > 0) {
          setSearch(res.data);
          setResult(false);
        } else if (res.data.length == 0 || value === "") {
          setQuestion(null);
          setResult(true);
          setActiveQuestionSearch("");
        }
        if (value === "") {
          setResult(false);
          setActive("-1");
          setSearch([]);
          setActiveQuestionSearch("");
        }
      })
      .catch((err: any) => {});
  };

  useEffect(() => {
    fetchFaqCategory();
  }, [location.pathname]);

  const fetchFaq = (id: any) => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/faq/` + id,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => {
      setActiveQuestion(res.data);
    });
  };

  const [activeKey, setActiveKey] = useState<any>([]);
  const [checkQuestion, setcheckQuestion] = useState("");

  function handlePanelClick(key: any) {
    setActiveKey(activeKey.includes(key) ? [] : [key]);
  }

  function changeActiveAll(question: any) {
    setActiveQuestion(question);
    //  setActiveAllQuestion(question.id);
    setActiveAllQuestion(question.id);
  }

  /*  return (
    <>
      <div style={{ paddingTop: "110px" }}>
        <div
          style={{
            height: "200px",
            backgroundColor: "#F8FAFF",
            textAlign: "center",
          }}
        >
          <div
            style={{
              paddingTop: "56px",
              fontSize: "20px",
              color: "#03468C",
              fontFamily: "Poppins",
            }}
          >
            Frequently asked questions
          </div>
          <div style={{ marginTop: "16px" }}>
            <form style={{ width: "100%" }}>
              <input
                type="text"
                placeholder="What are you looking for ?"
                name="name"
                className="option_details_input   ml-1 mb-0 ml-md-0"
                style={{ width: "50%" }}
                onChange={handleChange}
              />
            </form>
          </div>
        </div>
      </div>
      <div>
        {noResult == true ? (
          <>
            <div style={{ textAlign: "center" }}>
              {" "}
              <Result
                status="404"
                title="No Result"
                style={{ width: "100%" }}
                subTitle="Sorry, there's no result."
              />
            </div>
          </>
        ) : (
          <>
            <div>
              {search.length > 0 ? (
                <>
                  {search.map((q: any) => {
                    return (
                      <>
                        <div style={{ marginLeft: "27%" }}>
                          <div
                            style={{
                              border: "1px solid #CECECE",
                              marginLeft: "25px",
                              marginBottom: "25px",
                              borderRadius: "5px",
                              width: "60%",
                              padding: "25px",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {q.question}
                            </div>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: q.description,
                              }}
                            />
                          </div>
                        </div>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  <Tabs
                    defaultActiveKey="0"
                    activeKey={active}
                    centered
                    onChange={onChange}
                    id="tabs"
                  >
                    <Tabs.TabPane tab="All" key={"0"}>
                      <div style={{ marginLeft: "10%" }}>
                        <Row gutter={[48, 48]}>
                          {faqCategory.map((f: any) => {
                            return (
                              <>
                                <Col
                                  span={5}
                                  style={{
                                    border: "1px solid #CECECE",
                                    marginLeft: "25px",
                                    borderRadius: "5px",
                                    maxWidth: "100%",
                                    height: "auto",
                                    padding: "20px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "25px",
                                      color: "#00468C",
                                    }}
                                  >
                                    {f.name}
                                  </div>
                                  {f.faqs.slice(0, 4).map((faq: any) => {
                                    return (
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginBottom: "10px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        <Question></Question>{" "}
                                        <Link
                                          to={`/faq/${faq.id}`}
                                          style={{
                                            color: "black",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {faq.question}
                                        </Link>
                                      </div>
                                    );
                                  })}
                                  <a
                                    onClick={() => onChange("" + f.id + "")}
                                    style={{
                                      color: "black",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Show All
                                  </a>
                                </Col>
                              </>
                            );
                          })}
                        </Row>
                      </div>
                    </Tabs.TabPane>
                    {faqCategory.map((el: any) => {
                      return (
                        <Tabs.TabPane tab={el.name} key={el.id}>
                          {faq.map((el: any) => {
                            return (
                              <>
                                <div className="container">
                                  {el.faqs.map((f: any) => {
                                    return (
                                      <>
                                        <div
                                          style={{
                                            border: "1px solid #CECECE",
                                            marginBottom: "25px",
                                            borderRadius: "5px",
                                            padding: "25px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {f.question}
                                          </div>
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: f.description,
                                            }}
                                          />
                                        </div>
                                      </>
                                    );
                                  })}
                                </div>
                              </>
                            );
                          })}
                        </Tabs.TabPane>
                      );
                    })}
                  </Tabs>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  ); */

  return (
    <>
      <div style={{ paddingTop: "110px" }}>
        <div
          style={{
            height: "200px",
            backgroundColor: "#F8FAFF",
            textAlign: "center",
          }}
        >
          <div
            style={{
              paddingTop: "56px",
              fontSize: "20px",
              color: "#03468C",
              fontFamily: "Poppins",
            }}
          ></div>
          <div style={{ marginTop: "16px" }}>
            <input
              type="text"
              placeholder="What are you looking for ?"
              name="name"
              className="option_details_input   ml-1 mb-0 ml-md-0"
              style={{ width: "50%" }}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div>
        {noResult == true ? (
          <>
            <div style={{ textAlign: "center" }}>
              {" "}
              <Result
                status="404"
                title="No Result"
                style={{ width: "100%" }}
                subTitle="Sorry, there's no result."
              />
            </div>
          </>
        ) : (
          <>
            <div>
              {search.length > 0 ? (
                <>
                  <Row>
                    <Col span={12}>
                      {" "}
                      <div
                        style={{
                          marginLeft: "25px",
                          paddingTop: "15px",
                          color: "#00468C",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        Search Result
                      </div>
                      {search.map((q: any) => {
                        return (
                          <>
                            <a
                              onClick={() => {
                                setQuestion(q);
                                setActiveQuestionSearch(q.id);
                              }}
                              style={{
                                color: "#00468C",
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              <div
                                style={{
                                  textAlign: "left",
                                  marginTop: "20px",
                                }}
                              >
                                <div
                                  style={{}}
                                  className={
                                    activeQuestionSearch == q.id
                                      ? "activeSearchSelect"
                                      : "activeSearch"
                                  }
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {q.question}
                                  </div>
                                </div>
                              </div>
                            </a>
                          </>
                        );
                      })}
                    </Col>
                    <Col span={12}>
                      {" "}
                      {question && (
                        <>
                          {" "}
                          <div className="row1">
                            <div className="row title_container_post">
                              <div className="col-12">
                                <div
                                  style={{
                                    fontSize: "20px",
                                    color: "#03468C",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  {question.question}
                                </div>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: question.description,
                                  }}
                                ></div>
                                {question.video && (
                                  <video
                                    src={
                                      process.env.REACT_APP_STORAGE_URL +
                                      question.video
                                    }
                                    controls
                                    width="400"
                                    height="240"
                                  >
                                    {" "}
                                  </video>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  {active == "-1" && (
                    <div style={{ marginLeft: "10%", marginTop: "24px" }}>
                      <Row gutter={[24, 24]}>
                        {faqCategory.map((f: any) => {
                          return (
                            <>
                              <Col
                                span={5}
                                style={{
                                  border: "1px solid #CECECE",
                                  marginLeft: "25px",
                                  borderRadius: "5px",
                                  maxWidth: "100%",
                                  height: "auto",
                                  padding: "20px",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "20px",
                                    color: "#00468C",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {f.name}
                                </div>

                                {f.faqs.slice(0, 4).map((faqs: any) => {
                                  return (
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginBottom: "10px",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Question color={"#00468c"}></Question>{" "}
                                      <a
                                        onClick={() => {
                                          onChange("" + f.id + "");
                                          changeActiveAll(faqs);
                                          setcheckQuestion("");
                                        }}
                                        style={{
                                          color: "black",
                                          fontSize: "16px",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        {" "}
                                        {faqs.question}
                                      </a>
                                    </div>
                                  );
                                })}
                                <a
                                  onClick={() => {
                                    onChange("" + f.id + "");
                                    fetchFaq(f?.faqs[0]?.id);
                                    setcheckQuestion(f?.faqs[0]?.id);
                                  }}
                                  style={{
                                    color: "#004690",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    marginTop: "15px",
                                    marginBottom: "25px",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Show All
                                </a>
                              </Col>
                            </>
                          );
                        })}
                      </Row>
                    </div>
                  )}
                </>
              )}
            </div>
            {active != "-1" && (
              <div>
                {" "}
                {faq.map((el: any) => {
                  return (
                    <>
                      {" "}
                      <div className="products_page_container_faq">
                        <div className={`container-fluid products_page`}>
                          <div
                            className="filter"
                            style={{
                              borderRight: "1px solid #E4E4E4",
                            }}
                          >
                            <aside
                              className="asidefaq"
                              style={{ height: "100vh" }}
                            >
                              <div
                                style={{
                                  paddingLeft: "15px",
                                  paddingRight: "15px",
                                  paddingTop: "15px",
                                }}
                              ></div>

                              {/*  {el.faqs.map((faq: any) => {
                                return (
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      margin: "10px",

                                      padding: "10px 15px 5px 15px",
                                      borderRadius: "8px",
                                      height: "50px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setcheckQuestion(faq.id);
                                      setQuestion(null);
                                      setActiveAllQuestion(null);
                                      fetchFaq(faq.id);
                                      handlePanelClick(faq.id);
                                    }}
                                    className={
                                      checkQuestion == faq.id ||
                                      activeAllQuestion == faq.id
                                        ? "active-question"
                                        : ""
                                    }
                                  >
                                    <Question
                                      color={
                                        checkQuestion == faq.id ||
                                        activeAllQuestion == faq.id
                                          ? "#f8faff"
                                          : "#00468c"
                                      }
                                    ></Question>{" "}
                                    <button
                                      style={{
                                        color: "black",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {faq.question}
                                    </button>
                                    <Divider key={uuidv4()} />
                                  </div>
                                );
                              })} */}
                              <div>
                                {" "}
                                <div
                                  className="col-12 d-flex align-items-center back_cs"
                                  style={{ textAlign: "center" }}
                                >
                                  <img
                                    src={backArrow}
                                    className="back_arrow_folder mr-2"
                                    alt="back arrow"
                                    onClick={() => {
                                      setActive("-1");
                                    }}
                                  />
                                  <h1 style={{ fontSize: 16 }}>Go Back</h1>
                                </div>
                              </div>
                              <Divider key={uuidv4()} />
                              {faqCategory.map((f: any, key: any) => {
                                return (
                                  <Collapse
                                    defaultActiveKey={active}
                                    ghost
                                    expandIconPosition={"right"}
                                    expandIcon={(iconProp) =>
                                      iconProp.isActive ? (
                                        <FontAwesomeIcon icon={faMinus} />
                                      ) : (
                                        <FontAwesomeIcon icon={faPlus} />
                                      )
                                    }
                                  >
                                    <>
                                      <Panel header={f.name} key={f.id}>
                                        {" "}
                                        {f.faqs.map((faq: any) => {
                                          return (
                                            <div
                                              style={{
                                                fontSize: "16px",
                                                marginBottom: "10px",
                                                marginTop: "-7px",
                                                padding: "8px 15px 8px 15px",
                                                borderRadius: "8px",
                                              }}
                                              onClick={() => {
                                                setcheckQuestion(faq.id);
                                                setQuestion(null);
                                                setActiveAllQuestion(null);
                                                fetchFaq(faq.id);
                                                handlePanelClick(faq.id);
                                              }}
                                              className={
                                                checkQuestion == faq.id ||
                                                activeAllQuestion == faq.id
                                                  ? "active-question"
                                                  : ""
                                              }
                                            >
                                              <Question
                                                color={
                                                  checkQuestion == faq.id ||
                                                  activeAllQuestion == faq.id
                                                    ? "#f8faff"
                                                    : "#00468c"
                                                }
                                              ></Question>{" "}
                                              <button
                                                style={{
                                                  color: "black",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {faq.question}
                                              </button>
                                            </div>
                                          );
                                        })}
                                      </Panel>
                                      <Divider key={uuidv4()} />
                                    </>
                                  </Collapse>
                                );
                              })}
                            </aside>
                          </div>
                          {activeQuestion == null ? (
                            <div className="row1">
                              <div className="row title_container_post">
                                <div
                                  className="col-12"
                                  style={{ textAlign: "center" }}
                                >
                                  <>
                                    {search.length > 0 ? (
                                      <>
                                        <div
                                          style={{
                                            fontSize: "20px",
                                            color: "#03468C",
                                            fontFamily: "Poppins",
                                            textAlign: "left",
                                            marginLeft: "25px",
                                          }}
                                        >
                                          Search result
                                        </div>
                                        {search.map((q: any) => {
                                          return (
                                            <>
                                              <a
                                                onClick={() => {
                                                  setQuestion(q);
                                                  setActiveQuestionSearch(q.id);
                                                }}
                                                style={{
                                                  color: "#00468C",
                                                  fontSize: "14px",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    textAlign: "left",
                                                    marginTop: "20px",
                                                  }}
                                                >
                                                  <div
                                                    style={{}}
                                                    className={
                                                      activeQuestionSearch ==
                                                      q.id
                                                        ? "activeSearchSelect"
                                                        : "activeSearch"
                                                    }
                                                  >
                                                    <div
                                                      style={{
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {q.question}
                                                    </div>
                                                  </div>
                                                </div>
                                              </a>
                                            </>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            fontSize: "20px",
                                            color: "#03468C",
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          Frequently asked questions
                                        </div>
                                        <img
                                          src={faqbaseimage}
                                          alt="faqbaseimage"
                                        />
                                      </>
                                    )}
                                  </>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="row1">
                                <div className="row title_container_post">
                                  <div className="col-12">
                                    <div
                                      style={{
                                        fontSize: "20px",
                                        color: "#03468C",
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      {activeQuestion.question}
                                    </div>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: activeQuestion.description,
                                      }}
                                    ></div>
                                    {activeQuestion.video && (
                                      <video
                                        src={
                                          process.env.REACT_APP_STORAGE_URL +
                                          activeQuestion.video
                                        }
                                        controls
                                        width="400"
                                        height="240"
                                      >
                                        {" "}
                                      </video>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          {question && (
                            <>
                              {" "}
                              <div
                                className="row1"
                                style={{
                                  borderLeft: "1px solid #E0E0E0",
                                }}
                              >
                                <div className="row title_container_post">
                                  <div className="col-12">
                                    <div
                                      style={{
                                        fontSize: "20px",
                                        color: "#03468C",
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      {question.question}
                                    </div>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: question.description,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>

      {/*  <div className="products_page_container_faq">
        <div className={`container-fluid products_page`}>
          <div
            className="filter"
            style={{
              boxShadow: "8px 8px 6px -6px #E4E4E4",
              borderRight: "1px solid #E4E4E4",
            }}
          >
            <aside className="asidefaq" style={{ height: "100vh" }}>
              <div
                style={{
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  paddingTop: "15px",
                }}
              >
                <Input
                  size="large"
                  placeholder="What are you looking for ?"
                  prefix={<FontAwesomeIcon icon={faSearch} />}
                  onChange={handleChange}
                  onFocus={() => {
                    setActiveQuestionSearch("");
                    setcheckQuestion("");
                    setActiveQuestion(null);
                  }}
                />
              </div>

              {faqCategory.map((f: any) => {
                return (
                  <Collapse
                    defaultActiveKey={"1"}
                    ghost
                    expandIconPosition={"right"}
                    expandIcon={(iconProp) =>
                      iconProp.isActive ? (
                        <FontAwesomeIcon icon={faMinus} />
                      ) : (
                        <FontAwesomeIcon icon={faPlus} />
                      )
                    }
                  >
                    <>
                      <Panel header={f.name} key="1">
                        {" "}
                        {f.faqs.map((faq: any) => {
                          return (
                            <div
                              style={{
                                fontSize: "14px",
                                marginBottom: "10px",
                                marginTop: "10px",
                                padding: "5px 15px 5px 15px",
                                borderRadius: "8px",
                              }}
                              onClick={() => {
                                setcheckQuestion(faq.id);
                                setQuestion(null);
                              }}
                              className={
                                checkQuestion == faq.id ? "active-question" : ""
                              }
                            >
                              <Question
                                color={
                                  checkQuestion == faq.id
                                    ? "#f8faff"
                                    : "#00468c"
                                }
                              ></Question>{" "}
                              <button
                                onClick={() => {
                                  fetchFaq(faq.id);
                                  handlePanelClick(faq.id);
                                }}
                                style={{
                                  color: "black",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                {faq.question}
                              </button>
                            </div>
                          );
                        })}
                      </Panel>
                      <Divider key={uuidv4()} />
                    </>
                  </Collapse>
                );
              })}
            </aside>
          </div>
          {activeQuestion == null ? (
            <div className="row1">
              <div className="row title_container_post">
                <div className="col-12" style={{ textAlign: "center" }}>
                  {noResult == true ? (
                    <>
                      <div style={{ textAlign: "center" }}>
                        {" "}
                        <Result
                          status="404"
                          title="No Result"
                          style={{ width: "100%" }}
                          subTitle="Sorry, there's no result."
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {search.length > 0 ? (
                        <>
                          <div
                            style={{
                              fontSize: "20px",
                              color: "#03468C",
                              fontFamily: "Poppins",
                              textAlign: "left",
                              marginLeft: "25px",
                            }}
                          >
                            Search result
                          </div>
                          {search.map((q: any) => {
                            return (
                              <>
                                <a
                                  onClick={() => {
                                    setQuestion(q);
                                    setActiveQuestionSearch(q.id);
                                  }}
                                  style={{
                                    color: "#00468C",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <div
                                    style={{
                                      textAlign: "left",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <div
                                      style={{}}
                                      className={
                                        activeQuestionSearch == q.id
                                          ? "activeSearchSelect"
                                          : "activeSearch"
                                      }
                                    >
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {q.question}
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <div
                            style={{
                              fontSize: "20px",
                              color: "#03468C",
                              fontFamily: "Poppins",
                            }}
                          >
                            Frequently asked questions
                          </div>
                          <img src={faqbaseimage} alt="faqbaseimage" />
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row1">
                <div className="row title_container_post">
                  <div className="col-12">
                    <div
                      style={{
                        fontSize: "20px",
                        color: "#03468C",
                        fontFamily: "Poppins",
                      }}
                    >
                      {activeQuestion.question}
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: activeQuestion.description,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </>
          )}
          {question && (
            <>
              {" "}
              <div className="row1" style={{ borderLeft: "1px solid #E0E0E0" }}>
                <div className="row title_container_post">
                  <div className="col-12">
                    <div
                      style={{
                        fontSize: "20px",
                        color: "#03468C",
                        fontFamily: "Poppins",
                      }}
                    >
                      {question.question}
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: question.description,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div> */}
    </>
  );
};
